/**
 * Sin interfaz: termina de guardar las facturas que se quedaron a medias.
 *
 * El sitio natural para subir el original de una factura es justo después de
 * escanearla, y ahí se intenta. Pero ese momento es EL PEOR de todos: el móvil
 * acaba de volver de la cámara, la conexión del invernadero es la que es, y la
 * WebView de iOS puede morirse en cualquier instante entre el escaneo y la
 * subida. Los bytes quedan apuntados en IndexedDB (ver `invoiceFileOutbox`), y
 * lo que hace falta es alguien que vuelva a intentarlo cuando las condiciones
 * sean otras.
 *
 * Eso es esto. Dos ocasiones, las dos gratis:
 *
 *   - al entrar en la app con sesión (la de después de que el móvil se muriera);
 *   - cuando el navegador dice que ha vuelto la red.
 *
 * Va montado en el árbol de siempre, así que no depende de que nadie entre en
 * ninguna pantalla concreta: una factura escaneada el martes en el campo se
 * termina de guardar el miércoles al abrir la app en la oficina.
 */
import { useEffect } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { flushInvoiceFileOutbox } from "@/lib/archiveInvoiceFile";

export function InvoiceFileOutboxSync() {
  const { user, company } = useAuth();
  const ready = !!user?.id && !!company?.id;

  useEffect(() => {
    // Sin sesión no hay permisos para subir nada: se espera a que los haya.
    if (!ready) return;

    void flushInvoiceFileOutbox();

    const onOnline = () => { void flushInvoiceFileOutbox(); };
    window.addEventListener("online", onOnline);
    return () => window.removeEventListener("online", onOnline);
  }, [ready]);

  return null;
}
